import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import DGTable from 'jquery.dgtable';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import Filter from '../../../controls/Filter.js';
import DropDownBox from '../../../controls/DropDownBox.js';
import FiltersController from '../../../appHelpers/FiltersController.js';
import PhoneNumberUtil from '../../../utils/PhoneNumberUtil.mjs';
import ResizeManager from '../../../utils/ResizeManager.js';
import app from '../../App.js';
import EmptyScreenUI from '../../../appHelpers/EmptyScreenMessages.js';
import TableContextMenuUtil from '../../../appHelpers/TableContextMenu.js';
import TimeFormatters from '../../../appHelpers/TimeFormatters.js';

/** @class UserInfoReportPage */
const CallHistoryReportPage = View.extend(
    /** @lends UserInfoReportPage.prototype */
    {

        className: 'main-body',

        /** @constructs */
        initialize: function () {

            var that = this;

            // Add the title for this screen
            var $title = $('<div class="main-title">').appendTo(that.$el);
            $('<h1 class="main">').text(t('call_history_report.title')).appendTo($title);

            // Setup the space for action buttons
            var $buttonsBar = that.$buttonsBar = $('<div class="action-buttons">').append(
                $('<button class="action-refresh-button">').attr('title', t('refresh')).on('click', that.reload.bind(that))
            ).appendTo($title);

            // Create the dropdown for the download actions
            that.downloadDdl = new DropDownBox({ className: 'dropdown-action-download-box', defaultText: '', allowEmpty: true,
                position: 'end top',
                anchor: 'end bottom' })
                .addItem('csv', t('export_options', 'csv'))
                .addItem('xml', t('export_options', 'xml'));
            that.listenTo(that.downloadDdl, 'change', function () {
                var action = that.downloadDdl.val();
                that.downloadDdl.val(null);

                if (action === 'csv') {
                    that.exportAction(action);
                } else if (action === 'xml') {
                    that.exportAction(action);
                }

            });
            that.downloadDdl.$el.appendTo($buttonsBar);

            // Create the AUDIO object through which we play the recordings
            // TODO: Move audio player from here, recordings, and callEvents page to utils folder
            that.$player = $('<audio>');

            // Add the player bar
            this.setupPlayerBar();

            // Add the filters area
            that.$filtersArea = $('<div class="filters-area">').appendTo(that.$el).on('resize', function(){
                that.adjustSplitFrame();
            });

            // Create the space for the table and its preview data
            that.$splitArea = $('<div class="report-split-area"><div class="table-wrapper"></div><div class="data-area"></div></div>').appendTo(that.$el);

            // Setup the filters
            that.setupFilters();

            // Setup the table, and its automatic adjusting to its frame
            that.setupTable();
            that.table.render();
            that.listenTo(ResizeManager, 'resize', that.adjustSplitFrame);
            that.setTimeout(function () { that.adjustSplitFrame(); }, 0);

            that.reload();
        },

        setupFilters: function () {
            var that = this;

            var getFilterIds = function (key) {
                return (((that._filters.getValues(key, true) || {})[key] || {})['value'] || []).map(x => x.value).join(',');
            };

            var filterConfiguration = {
                'project_id': {
                    label: t('filters.project'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('projects', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },

                'team_id': {
                    label: t('filters.team'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,name'
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('teams', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: value['name']
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'user_id': {
                    label: t('filters.user_representative'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: function (request, response) {
                        var params = {
                            'fields': 'id,first_name,last_name',
                            'team_id': getFilterIds('team_id')
                        };
                        if (this._xhr) {
                            this._xhr.abort();
                        }
                        this._xhr = $.ajax({
                            url: app.apiUrl('users', params),
                            dataType: "json",
                            success: function (data) {
                                response(_.map(data, function (value) {
                                    return {
                                        value: value['id'],
                                        label: ((value['first_name'] || '') + ' ' + (value['last_name'] || '')).trim()
                                    };
                                }));
                            },
                            error: function () { response([]); }
                        });
                    },
                    cacheSource: true
                },
                'start_time': {
                    label: t('call_history_report.filters.start_time'),
                    type: Filter.FilterType.DATETIME
                },
                'status': {
                    label: t('call_history_report.filters.status'),
                    type: Filter.FilterType.MULTIOPTION,
                    source: t('call_history_statuses')
                },
                'net_duration': {
                    label: t('call_history_report.filters.net_duration'),
                    type: Filter.FilterType.NUMBER
                },
            };

            var queryFilters = null;
            var queryString = Backbone.history.getFragment().getQueryStringParams();
            if (queryString['filters']) {
                try {
                    queryFilters = JSON.parse(decodeURIComponent(atob(queryString['filters'])));
                } catch (e) { }
            }

            that._filters = new FiltersController({
                config: filterConfiguration,
                util: {
                    i18n: i18n,
                    getUserSetting: app.getUserSetting,
                    setUserSetting: app.setUserSetting,
                },
                saveKey: 'call_history_report',
                startWithValues: queryFilters,
                $panel: that.$filtersArea,

                callback: function (filterValues, type, action, value, andValue, mode) {
                    that.reload();
                    if (type === 'team_id') {
                        that._filters
                            .clearAutoCompleteCache('user_id')
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'user_id') {
                        that._filters
                            .clearAutoCompleteCache('project_id')
                            .clearAutoCompleteCache('campaign_id');
                    }
                    else if (type === 'project_id') {
                        that._filters
                            .clearAutoCompleteCache('campaign_id');
                    }
                }
            });

            return that;
        },

        setupTable: function () {
            var that = this;

            var columns = [
                {name: 'call_session_id', label: t('call_history_report.columns.call_session_id')},
                {name: 'user_fullname', label: t('call_history_report.columns.user_fullname')},
                {name: 'team_name', label: t('call_history_report.columns.team_name')},
                {name: 'phone', label: t('call_history_report.columns.phone'), cellClasses: 'ltr'},
                {name: 'start_time', label: t('call_history_report.columns.start_time')},
                {name: 'status', label: t('call_history_report.columns.status')},
                {name: 'gross_duration', label: t('call_history_report.columns.gross_duration')},
                {name: 'net_duration', label: t('call_history_report.columns.net_duration')},
                {name: 'channel', label: t('call_history_report.columns.channel')},
                {name: 'actions', label: t('call_history_report.columns.actions')}
            ];

            var tableConfigKey = 'call_history_report';
            app.TableAutoSavingConfigUtil.load(columns, tableConfigKey);

            var dateFormat = t('date_formats.normal_date_short_time');
            var statusOptions = t('call_history_statuses');

            var table = that.table = new DGTable({
                el: that.$splitArea.find('.table-wrapper')[0],
                columns: columns,
                width: DGTable.Width.SCROLL,
                convertColumnWidthsToRelative: true,
                cellFormatter: function (val, colName, row) {
                    if (colName === 'user_fullname') {
                        return (row['user_first_name'] || '') + ' ' + (row['user_last_name'] || '');
                    } else if (colName === 'phone') {
                        return PhoneNumberUtil.displayPhoneNumber(row['phone']);
                    } else if (colName === 'start_time') {
                        return val ? i18n.formatDate(new Date(val), dateFormat) : '';
                    }else if (colName === 'gross_duration') {
                        return TimeFormatters.timeFromSeconds(row['gross_duration']);
                    } else if (colName === 'net_duration') {
                        return TimeFormatters.timeFromSeconds(row['net_duration']);
                    } else if (colName === 'status') {
                        return statusOptions[val];
                    } else if (colName === 'actions') {
                        return '<div class="row-player stopped"><button class="play-pause"></button><button class="stop"></button><button class="download"></button></div>';
                    } else if (colName === 'call_session_id') {
                        return '<a href="/admin/reports/call_events?filters=' + encodeURIComponent(btoa(encodeURIComponent(JSON.stringify({
                            'session_id': {
                                'value': [
                                    {
                                        'value': row['call_session_id'],
                                        'mode': '='
                                    }
                                ]
                            }
                        })))) + '">' + val + '</a>';
                    }
                    return val;
                },
                comparatorCallback: function (columnName, descending) {
                    var leftValue = descending ? 1 : -1,
                        rightValue = descending ? -1 : 1;
                    if (columnName === 'user_fullname') {
                        return function (a, b) {
                            if (a['user_first_name'] < b['user_first_name']) return leftValue;
                            if (a['user_first_name'] > b['user_first_name']) return rightValue;
                            if (a['user_last_name'] < b['user_last_name']) return leftValue;
                            if (a['user_last_name'] > b['user_last_name']) return rightValue;
                            return 0;
                        };
                    }

                    return null;
                }
            });

            app.TableAutoSavingConfigUtil.setup(table, tableConfigKey);

            var createActionButtons = function ($cell, rowData) {
                var uniqueid = rowData['ami_uniqueid'];

                var $el = $cell.find('.row-player');
                if (!$el.length) return;

                var $player = that.$player;
                var player = $player[0];

                $el.find('>.play-pause').on('click', function () {

                    if ($el.hasClass('playing')) {
                        that.pauseRecordingByUniqueId(uniqueid);
                    }
                    else {
                        that.playRecordingByUniqueId(uniqueid);
                        that.$barControlArea.show();
                    }

                });

                $el.find('>.stop').on('click', function () {

                    that.stopRecordingByUniqueId(uniqueid);
                    that.$barControlArea.hide();

                });

                $el.find('>.download').on('click', function () {

                    var $a = $('<a>').attr('download', uniqueid + '.mp3').attr('href', that.streamUrl(uniqueid)).appendTo(document.body).on('click', function (event) {
                        event.stopPropagation(); // Prevent Router handlers from catching this
                    });
                    if ($a[0].click) {
                        $a[0].click();
                    } else {
                        $a.click();
                    }
                    $a.remove();

                });

                $player.on('play', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player playing';
                    }
                }).on('pause', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = (player.currentTime === 0 || player.currentTime === player.duration) ? 'row-player stopped' : 'row-player paused';
                    }
                }).on('abort', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                }).on('error', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                }).on('ended', function () {
                    if ($player.attr('uniqueid') === uniqueid) {
                        $el[0].className = 'row-player stopped';
                    }
                });

                var updateStatus = function () {
                    $el[0].className = 'row-player ' + ($player.attr('uniqueid') === uniqueid ?
                        (player.paused ?
                            (player.currentTime > 0 && player.currentTime < player.duration ? 'paused' : 'stopped') :
                            'playing') : 'stopped');
                };
                updateStatus();
            };

            table.on('rowcreate', function (filteredIndex, index, row, rowData) {

                row.className += index % 2 ? ' alt-row' : ' normal-row';

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    row.className += ' selected';
                }

                createActionButtons($('>div[data-column=actions]>div', row), rowData);

            }).on('cellpreview', function (el, rowIndex, col, rowData) {

                $(el).click(function () {
                    handleRowSelection(el, table.getRowElement(rowIndex), rowData);
                });

            }).on('rowdestroy', function (row) {

            }).on('headercontextmenu', function (columnName, pageX, pageY, cellBounds) {
                TableContextMenuUtil.setup(table, pageX, pageY);
                $.disableContextMenuForCurrentEvent();
            });

            var handleRowSelection = function (el, row, rowData) {

                if (that._selectedRow && that._selectedRow['id'] === rowData['id']) {
                    that.setSelectedRow();
                } else {
                    if (that._selectedRow) {
                        $(row.parentNode).find('.dgtable-row').removeClass('selected');
                    }
                    row.className += ' selected';
                    that.setSelectedRow(rowData);
                }

                if ($(el).closest('.dgtable-cell-preview').length) {
                    that.table.hideCellPreview();
                }
            };

            return that;
        },

        adjustSplitFrame: function () {
            var that = this;

            //TODO: recordings at the split area

            var $offsetParent = that.$splitArea.offsetParent();
            var offsetTop = that.$splitArea.offset().top - $offsetParent.offset().top;
            that.$splitArea.css({ 'height': $offsetParent.height() - offsetTop - 20 });

            if (that.table) {
                var lastTableSize = that._lastTableSize;
                var tableSize = {
                    width: that.table.$el.offsetParent().width(),
                    height: that.table.$el.offsetParent().height()
                };

                if (!lastTableSize || tableSize.height != lastTableSize.height) {
                    that.table.tableHeightChanged();
                } else if (!lastTableSize || tableSize.width != lastTableSize.width) {
                    that.table.tableWidthChanged();
                }
                that._lastTableSize = tableSize;
            }
            return that;
        },

        reload: function () {
            var that = this;

            var filters = that._filters.getValues(true);

            if (!filters || !Object.keys(filters).length || !filters['start_time']) {

                that.table.setRows([], true);

                if (that._loadXhr) {
                    that._loadXhr.abort();
                    that._loadXhr = null;

                    app.AlertUI.hideLoader(that.$el.closest('.main-body'));
                }

                that.setTimeout(function () {

                    if (!filters || !Object.keys(filters).length || !filters['start_time']) {

                        EmptyScreenUI.showEmptyScreenMessages(that.$el.closest('.main-body'),
                            (!filters || !Object.keys(filters).length || filters['start_time']) ? t('empty_screen_message') : t('choose_dates_filter_screen_message'));

                    }

                }, 0);

                return that;
            } else {
                EmptyScreenUI.hideEmptyScreenMessages(that.$el.closest('.main-body'));
            }

            if (that._isLoading) return that;

            var fields = '*';

            that._isLoading = true;
            that.ajaxGet(app.apiUrl('call_history'), { 'fields': fields, 'filters': JSON.stringify(that._filters.getValues(true)) })
                .always(function () {
                    that._isLoading = false;
                })
                .then(function (data) {
                    that.table.setRows(data, true);

                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

            return that;
        },

        render: function () {

            var that = this;

            return this;
        },

        setSelectedRow: function (row) {
            var that = this;
            that._selectedRow = row;

            if (!!row !== that.$splitArea.hasClass('is-split')) {
                that.$splitArea.toggleClass('is-split');
                that.table.tableHeightChanged();
            }

            that.$splitArea.find('.data-area').empty();

            if (!row) {
                return that;
            }

            return that;
        },

        /**
         *
         * @param {String} format
         */
        exportAction: function (format) {
            var that = this;

            var exportLoc = {
                'status_options': t('call_history_statuses'),
                'columns': t('call_history_report.columns')
            };

            var exportColumns = that.table.getColumnsConfig();
            exportColumns = Object.keys(exportColumns).filter(function (col) {
                return col !== 'actions' && exportColumns[col].visible !== false;
            }).sort(function (a, b) {
                a = exportColumns[a].order;
                b = exportColumns[b].order;
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            });

            var url = app.apiUrl('call_history', {
                'export': format,
                'export_columns': exportColumns.join(','),
                'export_lang': i18n.getActiveLanguage(),
                'export_loc': JSON.stringify(exportLoc),
                'filters': JSON.stringify(that._filters.getValues(true))
            });

            var iframe = $('<iframe>').hide().appendTo(document.body).attr('src', url)
                .on('load', function () {
                    // If the IFrame is loaded, then an error has occurred...
                    var responsJSON = null;
                    try {
                        responsJSON = iframe[0].contentDocument.body.textContent;
                        responsJSON = JSON.parse(responsJSON);
                    } catch (e) {

                    }
                    if (responsJSON && responsJSON['error']) {
                        app.showXhrError({ 'responseText': JSON.stringify(responsJSON) });
                    }
                });

            return that;
        },

        remove: function () {
            var that = this;

            if (that._filters) {
                that._filters.destroy();
            }

            that.constructor.__super__.remove.apply(this, arguments);
        },

        setupPlayerBar: function () {
            var that = this;

            // Add the player-bar area
            that.$barControlArea = $('\
            <div class="player-bar-area">\
                <div class="timer"></div>\
                <div class="bar">\
                  <div class="bar-handle"></div>\
                </div>\
            </div>').appendTo(that.$buttonsBar);

            var $timer = that.$barControlArea.find('.timer'),
                $bar = that.$barControlArea.find('.bar'),
                $handle = that.$barControlArea.find('.bar-handle'),
                $player = that.$player,
                player = $player[0];

            var calculateValueForBar = function (x, barBounds, handleWidth) {
                var effectiveWidth = barBounds.width - handleWidth;
                return Math.min(Math.max(x - barBounds.left, 0), effectiveWidth) / effectiveWidth;
            };

            var updateBarPosition = function (event, updatePlayerTime) {

                var value,
                    barBounds = $bar[0].getBoundingClientRect(),
                    handleWidth = $handle.outerWidth();

                if (arguments[0] instanceof Event || arguments[0] instanceof $.Event) {
                    value = calculateValueForBar(arguments[0].pageX, barBounds, handleWidth);
                } else {
                    value = arguments[0];
                }

                $handle.css({
                    'left': value * (barBounds.width - handleWidth)
                });

                if (updatePlayerTime) {
                    $player[0].currentTime = (player.duration * value) || 0;
                }

            };

            var updateTimerDisplay = function () {

                var currentPosition = player.currentTime || 0;
                var totalTime = player.duration || 0;

                var newText = '';

                if (player.error) {
                    newText = 'ERR';
                } else {
                    newText = TimeFormatters.timeFromSeconds(currentPosition) +
                        " / " +
                        TimeFormatters.timeFromSeconds(totalTime);
                }

                // If we want to select and copy timer, do not blink
                if ($timer.text() != newText) {
                    $timer.text(newText);
                }

                updateBarPosition((currentPosition / totalTime) || 0);

            };

            var beginDragging = function (event) {

                $(window).on('mousemove.draggable-player-bar', function (event) {

                    event.preventDefault(); // Prevent selection, as `user-select` CSS is not enough
                    updateBarPosition(event, true);

                }).on('mouseup.draggable-player-bar', function (event) {

                    $(window).off('.draggable-player-bar');

                    updateBarPosition(event, true);

                });

                updateBarPosition(event);
            };

            $handle.on('mousedown', function (event) {
                if (event.which !== 1) return; // Only with left button

                beginDragging(event);
            });

            $bar.on('mousedown', function (event) {
                if (event.which !== 1) return; // Only with left button
                if (event.target === $handle[0] || $handle.has(event.target).length) return;
                beginDragging(event);
            });

            $player.on('timeupdate', _.throttle(function() {
                updateTimerDisplay();
            }, 30)).on('loadstart', function() {
                updateTimerDisplay();
            }).on('error', function() {
                updateTimerDisplay();
            }).on('durationchange', function() {
                updateTimerDisplay();
            });

            that.$barControlArea.hide();

            return that;
        },

        streamUrl: function (uniqueid) {
            return app.apiUrl('recordings/stream', { 'uniqueid': uniqueid }, false);
        },

        playRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') !== uniqueid) {
                that.$player[0].src = '';
                that.$player.trigger('abort');

                that.$player.attr('uniqueid', uniqueid);
                that.$player[0].src = that.streamUrl(uniqueid);
            }

            that.$player[0].play();

            return that;
        },

        pauseRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') === uniqueid) {
                that.$player[0].pause();
            }

            return that;
        },

        stopRecordingByUniqueId: function (uniqueid) {
            var that = this;

            if (that.$player.attr('uniqueid') === uniqueid) {
                that.$player[0].pause();
                that.$player[0].currentTime = 0;
            }

            return that;
        }

    }
);

export default CallHistoryReportPage;
